import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content", "subject"]
  static values = { url: String }

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
  }

  async open(event) {
    const row = event.currentTarget
    const logId = row.dataset.logId
    if (!logId) return

    this.subjectTarget.textContent = 'Loading...'
    this.contentTarget.textContent = ''
    this.show()

    try {
      const response = await fetch(`${this.urlValue}/${logId}`, {
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        }
      })

      if (response.ok) {
        const data = await response.json()
        this.subjectTarget.textContent = data.subject || 'No subject'
        this.contentTarget.textContent = data.content || 'No content available'
      } else {
        this.contentTarget.textContent = 'Failed to load email content.'
      }
    } catch (error) {
      this.contentTarget.textContent = 'Failed to load email content.'
    }
  }

  close() {
    this.modalTarget.classList.add('hidden')
    document.body.classList.remove('overflow-hidden')
    document.removeEventListener('keydown', this.handleKeydown)
    this.contentTarget.textContent = ''
    this.subjectTarget.textContent = ''
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  // Private

  show() {
    this.modalTarget.classList.remove('hidden')
    document.body.classList.add('overflow-hidden')
    document.addEventListener('keydown', this.handleKeydown)
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }
}
